module.exports = __webpack_public_path__ + "img/sankaku_46_red.2ddb7d75.png";